import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';
import PickingCreate from './PickingCreate';
import PickingList from './PickingList';
import PickingHistory from './PickingHistory';

const PickingTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    const hash = location.hash;
    if (hash === '#list') {
      setTabValue(1);
    } else if (hash === '#history') {
      setTabValue(2);
    } else {
      setTabValue(0);
      if (hash === '') {
        navigate('/picking/picking_list#create', { replace: true });
      }
    }
  }, [location.hash, navigate]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    const hashMap = ['#create', '#list', '#history'];
    navigate(`/picking/picking_list${hashMap[newValue]}`, { replace: true });
  };

  const renderTabContent = () => {
    switch (tabValue) {
      case 0:
        return <PickingCreate />;
      case 1:
        return <PickingList />;
      case 2:
        return <PickingHistory />;
      default:
        return <PickingCreate />;
    }
  };

  return (
    <>
      <Box className="page-container">
        <Box className="paper-style">
          <Tabs
            sx={{ px: 2 }}
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            className="common-tabs"
          >
            <Tab label="Create Picking" />
            <Tab label="Picking List" />
            <Tab label="Picking History" />
          </Tabs>
          <Box>
            {renderTabContent()}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default PickingTabs;

